import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  Stack,
  Typography,
  CircularProgress,
  Paper,
  OutlinedInput,
  Grid,
  FormLabel,
  FormControlLabel,
  Select,
  MenuItem,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ReactDataGrid from "@inovua/reactdatagrid-community";
import "@inovua/reactdatagrid-community/base.css";
import "@inovua/reactdatagrid-community/theme/blue-light.css";
import "@inovua/reactdatagrid-community/theme/blue-dark.css";
import "@inovua/reactdatagrid-community/theme/amber-light.css";
import "@inovua/reactdatagrid-community/theme/amber-dark.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReportDataEditDialog from "./PhanMemEditDialog";
import SimpleDialog from "../components/SimpleDialog";
import { filterStyles } from "../components/common";
import moment from "moment";
import SelectFilter from "react-select";
import QuyenPhanMemDialog from "./QuyenPhanMemDialog";
import NhomQuyenEditDialog from "./NhomQuyenEditDialog";

const myLib = require("../lib/MyLib");
const server = require("../lib/server");

const PhanLoaiBenCang = [
  "Vùng đón trả hoa tiêu",
  "Cảng thường",
  "Vùng neo",
  "Phân cảng dầu khí",
  "",
  "Bến phao",
];
const columns_grid = [
  {
    name: "SCD",
    header: "Mã PM",
    headerAlign: "center",
    defaultWidth: 85,
  },
  {
    name: "GRCD",
    header: "Mã nhóm",
    headerAlign: "center",
    defaultWidth: 115,
  },
  {
    name: "GRNM",
    header: "Tên nhóm quyền",
    headerAlign: "center",
    defaultWidth: 350,
  },
  {
    name: "UPUSCD",
    header: "Người CN",
    headerAlign: "center",
    defaultWidth: 120,
  },
  {
    name: "UPTM",
    header: "Ngày CN",
    headerAlign: "center",
    defaultWidth: 150,
    render: (props) => moment(props.data.UPTM).format("DD/MM/YYYY HH:mm"),
  },
];
const defaultSortInfo = { name: "TenCang", dir: -1, type: "string" };
const loadDataError = (error, empty, log, trace) => {
  return !error ? (
    <b
      style={{
        padding: 8,
        border: "1px solid #7986cb",
        color: "#0000ff",
        borderRadius: 4,
      }}
    >
      {error ? log : empty ? "Không có bản ghi nào!" : ""}
    </b>
  ) : (
    <a
      href="#"
      style={{ textDecoration: "none" }}
      onClick={() =>
        toast.error(trace, {
          position: "top-center",
          autoClose: false,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        })
      }
    >
      <b
        style={{
          padding: 8,
          border: "1px solid #7986cb",
          color: "red",
          borderRadius: 4,
        }}
      >
        {error ? log : empty ? "Không có bản ghi nào!" : ""}
      </b>
    </a>
  );
};
export default class NhomQuyenDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorMessage: "", //mo ta loi neu co
      errorLog: "", //mo ta chi tiet loi
      loading_coquan: true, // co dang load ding danh muc nguon tin ko
      //searching
      search_loading: false,
      search_result: { data: [], count: 0 }, //ket qua tim kiem
      search_dataSource: [],
      search_error: false, //search co loi khong

      DanhSachPhanMem: [],
      DanhSachNhomQuyen: [],
      listData: [],
      after: {
        SCD: window.SoftCode,
        GRCD: "",
        GRNM: "",
      },
      PhanMem: { SCD: null, SNM: "" },
      rowSelected: undefined, //dang lua chon row nao
      showEditDialog: false, // hien thi form cap nhat hay khong
      edittingRecord: undefined, //ban ghi chon de edit
      showConfirmXoa: false, //hien thi dialog xoa
      hasQuyen: global.hasRoles("Admin"),
      open_show_edit_nhomquyen: false, //hien thi form quyen cua phan mem
    };
  }

  componentDidMount() {
    this.loadDanhMuc();
  }
  //call khi user thay doi trang
  static getDerivedStateFromProps(nextProps, prevState) {
    return { open: nextProps.open };
  }
  handleClose(selection) {
    this.props.close(selection);
  }
  handleServerError(error) {
    var message = "";
    var log = "";
    try {
      var obj = JSON.parse(error);
      message = obj.message;
      log = obj.traceLog;
      var log_detail = JSON.parse(log);

      if (log_detail && log_detail.Message) {
        message += "\n<br>" + log_detail.Message;
        if (log_detail.ExceptionMessage) {
          message = log_detail.ExceptionMessage + "\n" + message;
        }
      }
    } catch (e) {
      message = error + "";
    }
    toast.error(message, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
    });
  }
  saveField = (fieldName, value) => {
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = true;
    s.canSaved = s.dataChanged;
    if (fieldName !== "PageIndex") {
      s.after.PageIndex = 1;
    }
    if (fieldName !== "PageSize" && fieldName !== "PageIndex") {
      this.setState(this.state);
    } else {
      this.setState(this.state, () => {
        this.doSearch();
      });
    }
    this.setState(this.state);
  };
  saveData = (obj) => {
    var old_changed = this.state.dataChanged;
    var s = this.state;
    s = { ...s, after: { ...s.after, ...obj } };
    s.dataChanged = true;
    s.canSaved = s.dataChanged;
    this.setState(s);
  };
  loadDanhMuc() {
    this.setState({ loading_data: true });
    server
      .query("PhanQuyen/GetDanhSachPhanMem", {})
      .then((response) => {
        this.setState(
          {
            loading_data: false,
            search_error: false,
            DanhSachPhanMem: response,
          },
          () => this.doSearch()
        );
      })
      .catch((error) => {
        var message = "";
        var log = "";
        try {
          var obj = JSON.parse(error);
          message = obj.message;
          log = obj.traceLog;
        } catch (e) {
          message = error + "";
        }
        this.setState({
          loading_data: false,
          search_error: true,
          errorMessage: message,
          errorLog: log,
          rowSelected: undefined,
        });
      });
  }

  doSearch = () => {
    this.setState({ loading_data: true });
    server
      .query("PhanQuyen/GetNhomQuyen", { scd: this.state.after.SCD })
      .then((response) => {
        this.setState({
          loading_data: false,
          search_error: false,
          DanhSachNhomQuyen: response,
        });
      })
      .catch((error) => {
        var message = "";
        var log = "";
        try {
          var obj = JSON.parse(error);
          message = obj.message;
          log = obj.traceLog;
        } catch (e) {
          message = error + "";
        }
        this.setState({
          loading_data: false,
          search_error: true,
          errorMessage: message,
          errorLog: log,
          rowSelected: undefined,
        });
      });
  };
  render() {
    let tau = this.state.tauData;
    return (
      <Dialog
        open={this.props.open}
        fullWidth={true}
        maxWidth={"lg"}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <AppBar sx={{ position: "relative" }}>
            <Stack direction="row">
              <Typography
                sx={{ ml: 2, flex: 1, verticalAlign: "center" }}
                variant="h6"
                component="div"
              >
                Danh mục nhóm quyền phần mềm
              </Typography>
              <Stack direction="row" spacing={4}>
                {this.state.loading_data ? (
                  <CircularProgress color="warning" size={24} />
                ) : null}
                {this.state.saving ? (
                  <CircularProgress color="warning" size={24} />
                ) : null}
                <Button
                  color="success"
                  variant="contained"
                  onClick={() => {
                    var scd = this.state.after.SCD;
                    var phanmem = this.state.DanhSachPhanMem.find(
                      (item) => item.SCD === scd
                    );
                    this.setState({
                      open_show_edit_nhomquyen: true,
                      PhanMem: phanmem,
                    });
                  }}
                >
                  Thêm
                </Button>
                <Button
                  color="success"
                  variant="contained"
                  disabled={this.state.rowSelected === undefined}
                  onClick={() => {
                    var scd = this.state.rowSelected.SCD;
                    var phanmem = this.state.DanhSachPhanMem.find(
                      (item) => item.SCD === scd
                    );
                    this.setState({
                      open_show_edit_nhomquyen: true,
                      PhanMem: phanmem,
                      edittingRecord: this.state.rowSelected,
                    });
                  }}
                >
                  Sửa
                </Button>
                <Button
                  color="success"
                  variant="contained"
                  disabled={this.state.rowSelected === undefined}
                  onClick={() => {
                    this.setState({ showConfirmXoa: true });
                  }}
                >
                  Xóa
                </Button>
                
                <Button
                  color="success"
                  variant="contained"
                  onClick={() => this.handleClose(undefined)}
                >
                  Thoát
                </Button>
              </Stack>
            </Stack>
          </AppBar>
          <Paper variant="outlined">
            <Grid container spacing={1} columns={12}>
              <Grid item xs={1}>
                <FormLabel>Phần mềm:</FormLabel>
              </Grid>
              <Grid item xs={5}>
                <Select
                  fullWidth
                  value={this.state.after.SCD}
                  onChange={(event) =>
                    this.saveField("SCD", event.target.value)
                  }
                >
                  {this.state.DanhSachPhanMem.map((item) => (
                    <MenuItem value={item.SCD}>
                      {item.SCD} - {item.SNM}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item xs={2}>
                <Button
                  variant="contained"
                  startIcon={<SearchIcon fontSize="small" />}
                  onClick={this.doSearch}
                >
                  Tìm kiếm
                </Button>
              </Grid>
            </Grid>
          </Paper>
          <ReactDataGrid
            style={{ height: 450, fontSize: 12 }}
            showZebraRows={true}
            columns={columns_grid}
            multiSelect={false}
            showHoverRows={false}
            checkboxColumn={{
              render: (props) => (
                <input
                  type="checkbox"
                  readOnly
                  checked={props.rowSelected}
                ></input>
              ),
            }}
            dataSource={this.state.DanhSachNhomQuyen}
            idProperty="GRCD"
            headerHeight={30}
            rowHeight={30}
            defaultSortInfo={defaultSortInfo}
            onSortInfoChange={this.onSortInfoChange}
            emptyText={loadDataError(
              this.state.search_error,
              this.state.search_result.data.length === 0,
              this.state.errorMessage,
              this.state.errorLog
            )}
            skipLoadOnMount={true}
            enableSelection={true}
            onSelectionChange={({ data, selected, unselected }) => {
              this.setState({ rowSelected: data });
            }}
          ></ReactDataGrid>
        </DialogContent>
        {this.state.open_show_edit_nhomquyen ? (
          <NhomQuyenEditDialog
            open={true}
            MaPhanMem={this.state.after.SCD}
            PhanMem={this.state.PhanMem}
            edittingRecord={this.state.edittingRecord}
            close={(record) => {
              this.setState({
                open_show_edit_nhomquyen: false,
                edittingRecord: undefined,
              });
            }}
          />
        ) : null}
        {this.state.showConfirmXoa ? (
          <SimpleDialog
            confirm
            message={
              "Bạn muốn xóa nhóm quyền:" + this.state.rowSelected.GRCD + " ?"
            }
            open={true}
            close={(ok) => {
              if (ok) {
                //thuc hien xoa
                server
                  .post("PhanQuyen/XoaNhomQuyen", {
                    SCD: this.state.rowSelected.SCD,
                    GRCD: this.state.rowSelected.GRCD,
                  })
                  .then((response) => {
                    this.setState({ showConfirmXoa: false });
                    //reload
                    this.doSearch();
                  })
                  .catch((error) => {
                    this.setState({ showConfirmXoa: false });
                    this.handleServerError(error);
                  });
              } else {
                this.setState({ showConfirmXoa: false });
              }
            }}
          />
        ) : null}
        
      </Dialog>
    );
  }
}
